export default __webpack_public_path__ + "static/media/test-1920x1080.e6f7d8b8.png";